module.exports = __webpack_public_path__ + "static/media/sqlserver.b0d5c79b.svg";